import React, { useState, useRef, useEffect } from "react";

const BITACORA_KEY = 'honeypress_bitacora';

function loadBitacora() {
  try {
    const data = localStorage.getItem(BITACORA_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
}

function saveBitacora(entries) {
  localStorage.setItem(BITACORA_KEY, JSON.stringify(entries));
}



export default function Bitacora() {


  const [entries, setEntries] = useState(loadBitacora());
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [variedad, setVariedad] = useState("");
  const [tipoMaterial, setTipoMaterial] = useState("flores");
  const [temperatura, setTemperatura] = useState("");
  const [humedad, setHumedad] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [presion, setPresion] = useState("");
  const [presionUnidad, setPresionUnidad] = useState("bar");
  const [descripcion, setDescripcion] = useState("");
  const [error, setError] = useState("");
  const [formOpen, setFormOpen] = useState(true);
  const [tituloSesion, setTituloSesion] = useState(() => localStorage.getItem('bitacora_titulo') || 'Nueva Sesión');
  const [search, setSearch] = useState("");

  const fileInputRef = useRef();

  const filteredEntries = entries.filter(entry => {
    if (!search.trim()) return true;
    const s = search.trim().toLowerCase();
    return (
      (entry.variedad && entry.variedad.toLowerCase().includes(s)) ||
      (entry.descripcion && entry.descripcion.toLowerCase().includes(s)) ||
      (entry.tituloSesion && entry.tituloSesion.toLowerCase().includes(s))
    );
  });

  useEffect(() => {
    setPreview(image ? URL.createObjectURL(image) : null);
    return () => preview && URL.revokeObjectURL(preview);
    // eslint-disable-next-line
  }, [image]);

  // CSS para ajustar la imagen al recuadro sin importar resolución
  // Esto debe ir en el style de la imagen o en la clase CSS
  const imageStyle = {
    maxWidth: '100%',
    maxHeight: '300px', // o el alto del recuadro
    objectFit: 'contain',
    borderRadius: '16px',
    boxShadow: '0 2px 10px 0 rgba(255,179,0,0.10)'
  };


  useEffect(() => {
    localStorage.setItem('bitacora_titulo', tituloSesion);
  }, [tituloSesion]);

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (file && file.size > 50 * 1024 * 1024) {
      setError("La imagen no debe superar los 50MB.");
      return;
    }
    setImage(file);
    setError("");
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!variedad || !temperatura || !humedad || !tiempo || !presion || !descripcion) {
      setError("Por favor completa todos los campos.");
      return;
    }
    if (descripcion.split(/\s+/).length > 150) {
      setError("La descripción no debe superar las 150 palabras.");
      return;
    }
    const reader = new FileReader();
    reader.onload = function(ev) {
      const newEntry = {
        id: Date.now(),
        image: image ? ev.target.result : null,
        variedad,
        tipoMaterial,
        temperatura,
        humedad,
        tiempo,
        presion,
        presionUnidad,
        descripcion,
        tituloSesion,
        fecha: new Date().toLocaleString()
      };
      const updated = [newEntry, ...entries];
      setEntries(updated);
      saveBitacora(updated);
      setImage(null);
      setPreview(null);
      setVariedad("");
      setTemperatura("");
      setHumedad("");
      setTiempo("");
      setPresion("");
      setDescripcion("");
      setError("");
      if (fileInputRef.current) fileInputRef.current.value = "";
    };
    if (image) {
      reader.readAsDataURL(image);
    } else {
      reader.onload({target:{result:null}});
    }
  };

  const handleDelete = id => {
    const updated = entries.filter(e => e.id !== id);
    setEntries(updated);
    saveBitacora(updated);
  };

  const [navbarHeight, setNavbarHeight] = useState(100);
  useEffect(() => {
    function updateNavbarHeight() {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        setNavbarHeight(navbar.offsetHeight);
      } else {
        setNavbarHeight(100);
      }
    }
    updateNavbarHeight();
    window.addEventListener('resize', updateNavbarHeight);
    return () => window.removeEventListener('resize', updateNavbarHeight);
  }, []);

  return (
    <div style={{background:'#000', minHeight:'calc(100vh - 96px)', paddingTop:16, paddingBottom:120, overflowY:'auto', height:'calc(100vh - 96px)'}}>
      <div style={{maxWidth: 800, margin: '0 auto', padding: '2em'}}>
        <h1 style={{
          color: '#fff',
          fontSize: '2em',
          fontWeight: 800,
          letterSpacing: '.01em',
          marginBottom: '16px'
        }}>Bitácora de Prensadas</h1>
        <div style={{marginBottom:16}}>
          <div style={{display:'flex',alignItems:'center',background:'#ffecb3',borderRadius:8,padding:'10px 18px',boxShadow:'0 1px 4px #eee',cursor:'pointer'}} onClick={()=>setFormOpen(o=>!o)}>
            <span style={{fontWeight:'bold',fontSize:'1.08em',marginRight:12,color:'#000'}}>Nombra tu sesión:</span>
            <input type="text" value={tituloSesion} onChange={e=>setTituloSesion(e.target.value)} maxLength={50} style={{fontWeight:'bold',fontSize:'1.07em',background:'transparent',border:'none',outline:'none',flex:1,color:'#000'}} />
            <span style={{fontSize:'1.3em',marginLeft:10,color:'#000'}}>{formOpen ? '▼' : '▶'}</span>
          </div>
          {formOpen && (
            <div style={{
              width: '100%',
              maxWidth: 700,
              margin: '0 auto',
              paddingBottom: 10,
            }}>
              <form onSubmit={handleSubmit} className="bitacora-form" style={{
                background:'#f7f7f7', borderRadius:14, padding:20, margin:'16px 0 0 0', boxShadow:'0 1px 8px #eee', 
                display:'flex', gap:16, alignItems:'flex-start', flexWrap:'wrap', flexDirection: window.innerWidth <= 700 ? 'column' : 'row',
                minWidth:0,
                boxSizing:'border-box'
              }}>
                <div style={{minWidth:160, maxWidth:200, flex:'0 0 160px', textAlign:'center', marginBottom: window.innerWidth <= 700 ? 18 : 0}}>
                  <label style={{display:'block',marginBottom:8,fontWeight:'bold'}}>Imagen</label>
                  {preview ? (
                    <img src={preview} alt="preview" style={imageStyle} />
                  ) : (
                    <div style={{width:140, height:140, background:'#eee', borderRadius:12, marginBottom:8, display:'flex',alignItems:'center',justifyContent:'center',color:'#aaa'}}>Sin imagen</div>
                  )}
                  <input 
                    type="file" 
                    accept="image/*" 
                    onChange={handleImageChange} 
                    ref={fileInputRef} 
                    id="bitacora-file-input"
                    style={{display:'none'}}
                  />
                  <label htmlFor="bitacora-file-input" 
                    style={{
                      display:'inline-block',
                      background:'#ffe082',
                      color:'#b67c00',
                      fontWeight:'bold',
                      borderRadius:'8px',
                      padding:'7px 14px',
                      fontSize:'0.97em',
                      cursor:'pointer',
                      marginTop:6,
                      border:'1.2px solid #ffd54f',
                      boxShadow:'0 1px 3px #ffe082',
                      transition:'background 0.18s,border 0.18s'
                    }}
                  >Seleccionar archivo</label>
                </div>
                <div style={{flex:'1 1 320px',display:'flex',flexDirection:'column',gap:10,minWidth:200}}>
                  <input type="text" maxLength={40} placeholder="Variedad" value={variedad} onChange={e=>setVariedad(e.target.value)} />
                  <select value={tipoMaterial} onChange={e=>setTipoMaterial(e.target.value)} style={{flex:1,minWidth:90}}>
                    <option value="flores">Flores</option>
                    <option value="drysift">Dry Sift</option>
                    <option value="bubble-hash">Bubble Hash</option>
                  </select>
                  <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                    <input type="number" min="0" max="120" step="0.1" placeholder="Temperatura (°C)" value={temperatura || ''} onChange={(e) => {
                      const value = e.target.value;
                      if (value === '') {
                        setTemperatura('');
                      } else {
                        const num = parseFloat(value);
                        if (!isNaN(num) && num >= 0 && num <= 120) {
                          setTemperatura(num);
                        } else {
                          setTemperatura('');
                        }
                      }
                    }} style={{flex:1,minWidth:90}} />
                    <input type="number" min="0" max="100" step="0.1" placeholder="Humedad (%)" value={humedad || ''} onChange={(e) => {
                      const value = e.target.value;
                      if (value === '') {
                        setHumedad('');
                      } else {
                        const num = parseFloat(value);
                        if (!isNaN(num) && num >= 0 && num <= 100) {
                          setHumedad(num);
                        } else {
                          setHumedad('');
                        }
                      }
                    }} style={{flex:1,minWidth:90}} />
                  </div>
                  <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                    <input type="text" maxLength={20} placeholder="Tiempo (ej: 2 min)" value={tiempo} onChange={e=>setTiempo(e.target.value)} style={{flex:1,minWidth:90}} />
                    <div style={{display:'flex',gap:8,alignItems:'center'}}>
                      <input type="number" min="0" max="700" step="0.1" placeholder="Presión" value={presion || ''} onChange={(e) => {
                        const value = e.target.value;
                        if (value === '') {
                          setPresion('');
                        } else {
                          const num = parseFloat(value);
                          if (!isNaN(num) && num >= 0 && num <= 700) {
                            setPresion(num);
                          } else {
                            setPresion('');
                          }
                        }
                      }} style={{flex:1,minWidth:90}} />
                      <select value={presionUnidad} onChange={e => setPresionUnidad(e.target.value)} style={{minWidth:60}}>
                        <option value="bar">bar</option>
                        <option value="%">%</option>
                      </select>
                    </div>
                  </div>
                  <textarea maxLength={1000} rows={3} placeholder="Descripción breve (máx. 150 palabras)" value={descripcion} onChange={e=>setDescripcion(e.target.value)} style={{resize:'vertical',marginTop:4}} />
                  <button type="submit" style={{marginTop:8}}>Agregar a Bitácora</button>
                  {error && <div style={{color:'#c00',marginTop:4}}>{error}</div>}
                </div>
              </form>
            </div>
          )}
        </div>

        <h2 style={{marginBottom:12}}>Bitácora</h2>
        <div style={{background:'#fffde7',border:'1.5px solid #ffe082',color:'#a67c00',borderRadius:10,padding:'14px 18px',marginBottom:18,fontSize:'1em',boxShadow:'0 1px 4px #ffe082'}}>
          <b>Privacidad y tranquilidad:</b> Esta aplicación funciona sin conexión a internet y ninguno de tus datos se recopila ni se comparte. Todo lo que registres en tu bitácora solo será visible para ti, en este dispositivo. ¡Puedes anotar con total confianza!
        </div>
        <h3 style={{marginBottom:16}}>Tus Anotaciones</h3>
        <div style={{marginBottom:18}}>
          <input
            type="text"
            placeholder="Buscar por variedad, descripción o sesión..."
            style={{width:'100%',padding:'9px 14px',fontSize:'1em',border:'1px solid #ccc',borderRadius:6,outline:'none'}}
            value={search || ''}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        {filteredEntries.length === 0 && <div style={{color:'#888',margin:'2em 0'}}>No hay anotaciones que coincidan con tu búsqueda.</div>}
        <div style={{display:'flex',flexDirection:'column',gap:24}}>
          {filteredEntries.map(entry => (
            <div key={entry.id} style={{
              display:'flex',
              gap:18,
              background:'#fff9c4',
              borderRadius:13,
              border:'2px solid #ffe082',
              boxShadow:'0 2px 8px #ffe082',
              padding:16,
              alignItems:'flex-start',
              position:'relative',
              color:'#222',
            }}>
              {entry.image ? (
                <img src={entry.image} alt="bitacora" style={{width:120,height:120,objectFit:'cover',borderRadius:8,border:'1px solid #ccc'}} />
              ) : (
                <div style={{width:120,height:120,background:'#eee',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',color:'#aaa'}}>Sin imagen</div>
              )}
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:'bold',fontSize:'1.13em',color:'#b67c00',marginBottom:4, letterSpacing:0.5}}>{entry.tituloSesion}</div>
                <div style={{display:'flex',gap:16,flexWrap:'wrap',marginBottom:4,fontSize:'1.05em',color:'#222'}}>
                  <span><b style={{color:'#ffb300'}}>Variedad:</b> {entry.variedad}</span>
                  <span><b style={{color:'#ffb300'}}>Temperatura:</b> {entry.temperatura}°C</span>
                  <span><b style={{color:'#ffb300'}}>Humedad:</b> {entry.humedad}%</span>
                  <span><b style={{color:'#ffb300'}}>Tiempo:</b> {entry.tiempo}</span>
                  <span><b style={{color:'#ffb300'}}>Presión:</b> {entry.presion} {entry.presionUnidad}</span>
                </div>
              </div>
              <button onClick={() => handleDelete(entry.id)} style={{
                position:'absolute',
                right:16,
                top:16,
                background:'transparent',
                border:'none',
                color:'#b67c00',
                fontSize:'1.1em',
                cursor:'pointer',
                padding:0
              }}>❌</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
